export default __webpack_public_path__ + "a0fd6985ce687fe76451dc48cb8fb636.png";